/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationDocumentDetailAliases {
  CHECKBOX_UNDETERMINED_VALIDITY = 'checkbox-undetermined-validity',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_EXPIRATION_DATE = 'date-field-expiration-date',
  FETCH_DOCUMENT_DETAIL = 'fetch-document-detail',
  FIELD_0 = 'field-0',
  FIELD_EXPIRATION_DATE = 'field-expiration-date',
  FIELD_EXPIRATION_DATE_DISABLED = 'field-expiration-date-disabled',
  FIELD_FILE_UPLOADER = 'field-file-uploader',
  FIELD_ISSUE_DATE = 'field-issue-date',
  FIELD_ISSUE_DATE_DISABLED = 'field-issue-date-disabled',
  FIELD_UNDETERMINED_VALIDITY = 'field-undetermined-validity',
  FILE_UPLOADER = 'file-uploader',
  FORM_DOCUMENT_DETAIL = 'form-document-detail',
  INPUT_EXPIRATION_DATE = 'input-expiration-date',
  INPUT_ISSUE_DATE = 'input-issue-date',
  PANEL_DOCUMENT_DETAIL = 'panel-document-detail',
  TEXT_0 = 'text-0',
}
export { ProviderAccreditationDocumentDetailAliases };
